"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutsideRoute = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = require("styled-components");
var react_router_1 = require("react-router");
var theme_1 = require("remota-client/component/theme");
var login_1 = require("./login");
var login_apart_1 = require("./login-apart");
var tenant_1 = require("./tenant");
var password_1 = require("./password");
var legal_1 = require("./legal");
var invalid_1 = require("./invalid");
var otherwise_1 = require("./otherwise");
var external_jobs_1 = require("./external-jobs");
var notification_1 = require("./notification");
var notification_2 = require("app/hook/notification");
var OutsideRoute = function () { return (react_1.default.createElement(styled_components_1.ThemeProvider, { theme: theme_1.theme },
    react_1.default.createElement(react_router_1.Switch, null,
        react_1.default.createElement(react_router_1.Route, { exact: true, path: "/", component: login_1.LoginMain }),
        react_1.default.createElement(react_router_1.Route, { exact: true, path: "/login/:tenantId", component: login_apart_1.LoginApartMain }),
        react_1.default.createElement(react_router_1.Route, { exact: true, path: "/external/jobs/:jobId", component: external_jobs_1.ExternalJob }),
        react_1.default.createElement(react_router_1.Route, { exact: true, path: "/tenant/concur/connect", component: tenant_1.TenantConcurConnect }),
        react_1.default.createElement(react_router_1.Route, { exact: true, path: "/reset/:token", component: password_1.PasswordReset }),
        react_1.default.createElement(react_router_1.Route, { exact: true, path: "/create/:token", component: password_1.UserCreate }),
        react_1.default.createElement(react_router_1.Route, { exact: true, path: "/privacy", component: legal_1.PrivacyPolicy }),
        react_1.default.createElement(react_router_1.Route, { exact: true, path: "/terms", component: legal_1.TermsOfService }),
        react_1.default.createElement(react_router_1.Route, { exact: true, path: "/invalid/reset", component: invalid_1.InvalidReset }),
        react_1.default.createElement(react_router_1.Route, { exact: true, path: "/invalid/unauthorized", component: invalid_1.InvalidUnauthorized }),
        react_1.default.createElement(react_router_1.Route, { exact: true, path: "/invalid/create", component: invalid_1.InvalidUserCreate }),
        react_1.default.createElement(react_router_1.Route, { component: otherwise_1.Otherwise })),
    react_1.default.createElement(notification_1.Notification, { useNotification: notification_2.useNotification }))); };
exports.OutsideRoute = OutsideRoute;
